import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  saveTransactionConfirmationContainer: {
    textAlign: 'center',
    justifyContent: 'center',
    borderBottom: `1px solid ${themeColor.secondaryLight}`,
  },
  icon: {
    width: '2vw',
    height: '4.393vh',
    fill: theme.palette.secondary.main,
  },
  typography: { fontSize: rem(1.3), fontWeight: 500 },
}));
